import { render, staticRenderFns } from "./collectionformresult.vue?vue&type=template&id=2e138564&scoped=true&"
import script from "./collectionformresult.vue?vue&type=script&lang=js&"
export * from "./collectionformresult.vue?vue&type=script&lang=js&"
import style0 from "./collectionformresult.vue?vue&type=style&index=0&id=2e138564&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e138564",
  null
  
)

export default component.exports